import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import Typography from '../../Generic/Typography';
import { List, ListItem } from '../../Generic/List';
import { Checkbox } from '../../Generic/Selectors';
import styles from './ProductList-tw-styles';
import {
  Accordion,
  AccordionPanel,
  AccordionPanelDetails,
  AccordionPanelHeader,
} from '../../Generic/Accordion';

class FacetPanelRadio extends Component {
  static propTypes = {
    filter: PropTypes.oneOfType([PropTypes.object]).isRequired,
    index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    handleCheck: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    const { index } = props;
    this.state = {
      expand: index === 0 ? true : false,
    };
  }

  handleClick = () => {
    const { expand } = this.state;
    this.setState({
      expand: !expand,
    });
  };

  render() {
    const { filter, index, handleCheck, pageType } = this.props;
    let facetAccordion = styles.facet;
    const { expand } = this.state;
    return (
      <Accordion>
        <div key={index} className={classNames(styles.facet.categoryWrapper)}>
          <AccordionPanel key={index} accordionStyle={facetAccordion}>
            <AccordionPanelHeader
              panelIndex={index}
              handleClick={this.handleClick}
              isExpanded={expand}
              accordionStyle={facetAccordion}
              iconClassName="navigation_arrow"
              expanded={<span className={styles.facet.expandedIcon} />}
              collapsed={<span className={styles.facet.collapsedIcon} />}
            >
              <div>
                <Typography
                  component="div"
                  className={classNames(styles.facet.itemTitle)}
                >
                  {filter && filter.category_label}
                </Typography>
              </div>
            </AccordionPanelHeader>
            <AccordionPanelDetails
              isExpanded={expand}
              accordionStyle={facetAccordion}
              desktopCollapsible={false}
              smartphoneCollapsible={false}
            >
              { expand && <List className={classNames(styles.facet.itemUl)}>
                {filter.facet.map((t, i) => {
                  if (t.product_count > 0) {
                    return (
                      <ListItem
                        key={i}
                        title={t.title}
                        className={classNames(styles.facet.itemLi)}
                      >


                        <label
                          htmlFor={`${'selector-' + filter.id + '-' + i}`}
                          className={classNames(styles.facet.itemLabel)}
                        >
                          <Checkbox
                          id={`${'selector-' + filter.id + '-' + i}`}
                          name={`${'selector-' + filter.id}`}
                          checked={t.selected === true}
                          onChange={e => handleCheck(e, t, filter, pageType)}
                          className={classNames(styles.facet.itemCheckbox)}
                        />
                          <span className={classNames(styles.facet.itemText)}>
                            {t.name}
                          </span>
                        </label>
                      </ListItem>
                    );
                  }
                })}
              </List>}
            </AccordionPanelDetails>
          </AccordionPanel>
        </div>
      </Accordion>
    );
  }
}

FacetPanelRadio.propTypes = {
  pageType: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default observer(FacetPanelRadio);
